import { render, staticRenderFns } from "./EditArchive.vue?vue&type=template&id=af4fe102&scoped=true"
import script from "./EditArchive.vue?vue&type=script&lang=js"
export * from "./EditArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4fe102",
  null
  
)

export default component.exports